//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.GrantType

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The grant model.
* 
* @param grantType 
* @param clientId The client id
* @param clientSecret The client secret
* @param code The authorization code
* @param password The user password
* @param redirectUri The redirect uri
* @param refreshToken The refresh token
* @param scope The scopes - mandatory in the first request. If no scopes given in the refresh_token request, the initial set will be used.
* @param tfgDeviceId The device id
* @param userName The username - the unique user email
*/
@Serializable

data class GrantRequest (


      @SerialName(value = "grant_type") @Required val grantType: GrantType,


      /* The client id */
    @SerialName(value = "client_id") val clientId: kotlin.String? = null,


      /* The client secret */
    @SerialName(value = "client_secret") val clientSecret: kotlin.String? = null,


      /* The authorization code */
    @SerialName(value = "code") val code: kotlin.String? = null,


      /* The user password */
    @SerialName(value = "password") val password: kotlin.String? = null,


      /* The redirect uri */
    @SerialName(value = "redirect_uri") val redirectUri: kotlin.String? = null,


      /* The refresh token */
    @SerialName(value = "refresh_token") val refreshToken: kotlin.String? = null,


      /* The scopes - mandatory in the first request. If no scopes given in the refresh_token request, the initial set will be used. */
    @SerialName(value = "scope") val scope: kotlin.String? = null,


      /* The device id */
    @SerialName(value = "tfg_device_id") val tfgDeviceId: kotlin.String? = null,


      /* The username - the unique user email */
    @SerialName(value = "userName") val userName: kotlin.String? = null


) {




  }

